var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfollowChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50001 3C8.57815 3 7.46486 3.3358 6.56883 4.11496C5.64275 4.92024 5 6.15565 5 7.82609C5 10.7793 7.09969 13 9.50001 13C11.9003 13 14 10.7793 14 7.82609C14 6.15566 13.3573 4.92025 12.4312 4.11496C11.5352 3.3358 10.4219 3 9.50001 3ZM7 7.82609C7 6.71391 7.40726 6.03628 7.88118 5.62417C8.38515 5.18594 9.02188 5 9.50001 5C9.97815 5 10.6149 5.18594 11.1188 5.62417C11.5927 6.03628 12 6.71391 12 7.82609C12 9.88158 10.5997 11 9.50001 11C8.40033 11 7 9.88157 7 7.82609Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18.5117C2 15.6086 4.50313 14 9.5 14C14.4969 14 17 15.6086 17 18.5117C17 19.8885 13.6437 21 9.5 21C5.35625 21 2 19.8885 2 18.5117ZM4.82557 18.3738C4.46813 18.2553 4.21248 18.1401 4.04061 18.046C4.13708 17.5447 4.41091 17.1847 4.91997 16.8732C5.71453 16.3871 7.15813 16 9.5 16C11.8419 16 13.2855 16.3871 14.08 16.8732C14.5891 17.1847 14.8629 17.5447 14.9594 18.046C14.7875 18.1401 14.5319 18.2553 14.1744 18.3738C13.0706 18.7398 11.4181 19 9.5 19C7.58192 19 5.92944 18.7398 4.82557 18.3738ZM15.2149 17.875L15.2159 17.874C15.2159 17.874 15.2131 17.8763 15.2086 17.881L15.2149 17.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0816 9L22.4958 10.4142L17.5431 15.3669L17.5411 15.3648L17.539 15.3669L14.5858 12.4137L16 10.9995L17.5411 12.5405L21.0816 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollowChecked);
export default __webpack_public_path__ + "static/media/unfollowChecked.144da7d8b75f42813421557889ee349f.svg";
export { ForwardRef as ReactComponent };